import {ModelInstance, ToFrontHook, ToBackHook, BaseModel} from './util';

export enum SportTypes {
  basketball = 1,
  volleyball = 2,
  classic_basketball = 3,
  streetball = 4,
  classic_volleyball = 5,
  beach_volleyball = 6,
  hockey = 7,
  ice_hockey = 8,
  ball_hockey = 9,
  football = 10,
  classic_football = 11,
  mini_football = 12,
  handball = 13,
  handball_classic = 14,
  rugby = 15,
  rugby15 = 16,
  rugby7 = 17,
  basketball_1x1 = 18,
  waterpolo = 19,
  classic_waterpolo = 20,
  mini_waterpolo = 21,
  media_basket = 22,
  moneyball_basket = 23,
  wrestball= 24,
  wrestball_classic = 25,
  winline_basket = 26,
  dota_root = 27,
  dota = 28,
  cs_root = 29,
  cs = 30,
  other = 31,
  chess = 32,
  table_tennis = 33,
  billiard = 34,
  darts = 35,
  badminton = 36,
  padel_tennis = 37,
  other_dota = 38,
  other_fifa = 39,
  fonbase_basketball = 40,
}

@ModelInstance({
  mappingFields: {
    id: 'id',
    name: 'name',
    parent_id: 'parentId',
    sub_sports: 'subSports'
  }
})
export class Sport extends BaseModel {
  id: number;
  name: string;
  parentId: number;
  subSports: Sport[];

  isBasketball() {
    return this.id === SportTypes.basketball || this.parentId === SportTypes.basketball;
  }

  isClassicBasketball() {
    return this.id === SportTypes.classic_basketball;
  }

  isStreetball() {
    return this.id === SportTypes.streetball;
  }

  isBasketball1x1() {
    return this.id === SportTypes.basketball_1x1;
  }

  isMediaBasket() {
    return this.id === SportTypes.media_basket;
  }

  isFonbaseBasketball() {
    return this.id === SportTypes.fonbase_basketball;
  }

  isMoneyballBasket() {
    return this.id === SportTypes.moneyball_basket;
  }

  isWinlinebasket() {
    return this.id === SportTypes.winline_basket;
  }

  isVolleyball() {
    return this.id === SportTypes.volleyball || this.parentId === SportTypes.volleyball;
  }

  isClassicVolleyball() {
    return this.id === SportTypes.classic_volleyball;
  }

  isBeachVolleyball() {
    return this.id === SportTypes.beach_volleyball;
  }

  isHockey(): boolean {
    return this.id === SportTypes.hockey || this.parentId === SportTypes.hockey;
  }

  isIceHockey(): boolean {
    return this.id === SportTypes.ice_hockey;
  }

  isBallHockey(): boolean {
    return this.id === SportTypes.ball_hockey;
  }

  isFootball() {
    return this.id === SportTypes.football || this.parentId === SportTypes.football;
  }

  isClassicFootball() {
    return this.id === SportTypes.classic_football;
  }

  isMiniFootball() {
    return this.id === SportTypes.mini_football;
  }

  isHandball() {
    return this.id === SportTypes.handball || this.parentId === SportTypes.handball;
  }

  isHandballClassic() {
    return this.id === SportTypes.handball_classic;
  }

  isRugby() {
    return this.id === SportTypes.rugby || this.parentId === SportTypes.rugby;
  }

  isRugby15() {
    return this.id === SportTypes.rugby15;
  }

  isRugby7() {
    return this.id === SportTypes.rugby7;
  }

  isWaterpolo() {
    return this.id === SportTypes.waterpolo || this.parentId === SportTypes.waterpolo;
  }

  isClassicWaterpolo() {
    return this.id === SportTypes.classic_waterpolo;
  }

  isMiniWaterpolo() {
    return this.id === SportTypes.mini_waterpolo;
  }

  isWrestball() {
    return this.id === SportTypes.wrestball || this.parentId === SportTypes.wrestball;
  }

  isOther() {
    return this.id === SportTypes.other || this.parentId === SportTypes.other;
  }

  isIndividualSport() {
    return this.isOther() && this.id !== SportTypes.badminton;
  }

  @ToFrontHook
  static toFront(data: any): any {
    return null;
  }

  @ToBackHook
  static toBack(sport: Sport): any {
    return null;
  }
}
